import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import icon13 from "../../images/icon/sms-white-icon01.svg";
import logo from "../../images/logo/logo-resized.svg";
import avatar from "../../images/brand/iceskateleicester.jpeg";
import quote from "../../images/icon/quote.png";
import mImg from "../../images/casestudy/mm_img.png";
import MobileMenu from "../MobileMenu/MobileMenu";
import Services from "../../api/service";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [isSticky, setSticky] = useState(false);

  const splitServices = Services.slice(0, 3);
  const secondaryServices = Services.slice(3, 6);

  const coreLinks = [
    {
        title: "About Us",
        slug: "./about",
    },
    {
        title: "Our Team",
        slug: "./team",
    },
    {
        title: "Careers",
        slug: "./career",
    },
    {
        title: "Partners",
        slug: "./partners",
    }
  ]

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent"
    >
      <div className="header-top">
        <span>
          Join us at Pay360 at the Excel, London on the 25th of March 2025 🚀
        </span>
        <span>
          <Link onClick={ClickHandler} to="https://thepaymentsassociation.org/event/pay360-2025-25th-and-26th-march/">
            Learn more
          </Link>
          <i className="far fa-angle-right"></i>
        </span>
      </div>
      <div
        className={`xb-header stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between">
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="menu-item">
                    <Link onClick={ClickHandler} to="/">
                      <span>Home</span>
                    </Link>
                  </li>
                  <li className="megamenu">
                    <Link onClick={ClickHandler} to="/pricing">
                      <span>Pricing</span>
                    </Link>
                  </li>
                  <li className="megamenu">
                    <Link onClick={ClickHandler} to="/service">
                      <span>Services</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
                              <div className="row justify-content-lg-between">
                                <div className="col-xl-12">
                                  <div className="megamenu_widget_inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            {splitServices.map(
                                              (service, srv) => (
                                                <li
                                                  key={srv}
                                                  className="xb-item--list"
                                                >
                                                  {service.title ? (
                                                    <Link
                                                      onClick={ClickHandler}
                                                      to={`/service-single/${service.slug}`}
                                                    >
                                                      <span className="icon_list_text">
                                                        {service.title}
                                                      </span>
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            {secondaryServices.map(
                                              (service, srv) => (
                                                <li
                                                  key={srv}
                                                  className="xb-item--list"
                                                >
                                                  {service.title ? (
                                                    <Link
                                                      onClick={ClickHandler}
                                                      to={`/service-single/${service.slug}`}
                                                    >
                                                      <span className="icon_list_text">
                                                        {service.title}
                                                      </span>
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="social_area">
                                    <div className="social_inner ul_li">
                                      <h5>Follow Us:</h5>
                                      <ul className="social_icons_block unordered_list">
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-facebook-f"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-linkedin-in"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <svg
                                              width="18"
                                              height="18"
                                              viewBox="0 0 18 18"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M10.6774 7.62177L17.2342 0H15.6805L9.98719 6.61788L5.43998 0H0.195312L7.07159 10.0074L0.195312 18H1.74916L7.76141 11.0113L12.5636 18H17.8083L10.677 7.62177H10.6774ZM8.54921 10.0956L7.8525 9.09906L2.30903 1.16971H4.69564L9.16929 7.56895L9.866 8.56546L15.6812 16.8835H13.2946L8.54921 10.096V10.0956Z"
                                                fill="#0C111D"
                                              />
                                            </svg>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-dribbble"></i>
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <p className="career_link m-0">Looking for new
                                                                            career? <Link onClick={ClickHandler} to="/career">We’re
                                                                                Hiring</Link></p> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {/* <li>
                    <Link onClick={ClickHandler} to="/blog">
                      <span>News / Blog</span>
                    </Link>
                  </li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span>Contact</span>
                    </Link>
                  </li>
                </ul>
              </nav>
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>
                    <div className="xb-logo-mobile xb-hide-xl">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <nav className="xb-header-nav">
                      <MobileMenu />
                    </nav>
                  </div>
                </div>
                <div className="xb-header-menu-backdrop"></div>
              </div>
            </div>
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
            <div className="header-contact d-none d-md-block">
              <Link
                onClick={ClickHandler}
                to="https://algr.io"
                className="thm-btn thm-btn--aso thm-btn--header-black"
              >
                Login
              </Link>
              <Link
                onClick={ClickHandler}
                to="https://algr.io/register"
                className="thm-btn thm-btn--aso thm-btn--header-black2"
              >
                Register
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
